import '../../app.es6';
import angular from 'angular';

class AdminTopController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.schoolName = '';
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_S_ADMIN) {
      // 表示校名取得
      this.getCompaniesMeSchools();
    } else {
      // 表示校名
      this.schoolName = this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME];
    }

    Page.setTitle(this.Const.TITLE.topForSchoolAdmin);

    AdminTopController.$inject = ['$scope', '$sessionStorage',
                                  '$location', 'commonApiFactory',
                                  'commonFactory', 'Const', 'Page'];
  }

  getCompaniesMeSchools () {
    this.commonFactory.overlayShow();
    this.commonApiFactory.getAdminCompaniesMeSchools()
    .then((result) => {
      this.schoolList = [];
      result.forEach((school) => {
        let schoolObj = {
          id: school.id,
          name: school.name
        };
        this.schoolList.push(schoolObj);
      });
      let schoolFilter = this.schoolList.filter(function (item) {
        if (parseInt(item.id) === this.r) return true;
      }, { r: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] });
      if (Object.keys(schoolFilter).length > 0) {
        let targetSchool = schoolFilter.shift();
        this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = targetSchool.name;
        this.schoolName = this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME];
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  toCoachList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/admin/coach');
  }
  toMemberList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/admin/member');
  }
  toCourseList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.adminTop;
    this.$location.path('/admin/course');
  }
}

angular.module('myApp').controller('AdminTopController', AdminTopController);



// WEBPACK FOOTER //
// ./app/components/admin-top/admin-top-controller.es6